import CountUp from 'react-countup';

import DecreaseIcon from '@/assets/icons/DecreaseIcon';
import IncreaseIcon from '@/assets/icons/IncreaseIcon';
import { Flex } from '@/components/base';
import Heading from '@/components/Typography/Heading';
import useColor from '@/hooks/domain/useColor';

type Props = {
  count: number;
  changes: number | null;
};

const HeroCountDisplay = (props: Props) => {
  const color = useColor();
  return (
    <Flex g={12} a="center">
      <Heading type="h1" weight="b">
        <CountUp end={props.count || 0} duration={0.3} />
      </Heading>

      {props.changes !== null && (
        <Flex a="center" g={4}>
          <Heading
            color={Number(props.changes) >= 0 ? color.green500 : color.red600}
            type="h3"
          >
            {props.changes}%
          </Heading>

          {Number(props.changes) >= 0 ? <IncreaseIcon /> : <DecreaseIcon />}
        </Flex>
      )}
    </Flex>
  );
};

export default HeroCountDisplay;
